import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Pages, toCommands } from '../../../constants/pages';

export const defaultRouting: CanActivateChildFn = ({ queryParams }: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const { page = '' } = queryParams || {};

  if (page === 'joinrenewalhome') {
    router.navigate(toCommands(Pages.join), { queryParams });
    return false;
  }

  if (page === 'ClubServices11') {
    router.navigate(toCommands(Pages.account), { queryParams });
    return false;
  }

  if (page === 'ClubServices10') {
    router.navigate(toCommands(Pages.renew), { queryParams });
    return false;
  }

  if (page === 'ClubServices12') {
    router.navigate(toCommands(Pages.giftOffers), { queryParams });
    return false;
  }

  return true;
};

export default defaultRouting;
